<template>
  <div class="bg-stand" style="height: 100%">
    <top-header></top-header>
    <div class="update-body">
      <div class="toastr animated animate" v-if="close_toastr"
        :class="{ slideInRight: close_toastr, slideOutRight: !close_toastr }" style="z-index: 100000">
        <h4>
          Success
          <span class="closebtn" @click="closetoastr"> &times; </span>
        </h4>
        <p v-if="email_success">
          {{ email_success_text }}
        </p>
        <p v-if="data_success">Data updated successfully</p>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-5 update-body-nav">
          <p>
            <img src="@/assets/all-department-lllustration.svg" />
          </p>
          <h4 class="my-3">All Department</h4>
          <p class="text-center w-75 px-4">
            Add departments that will collaborate within your organization. You
            can also create folders for each department in the group folder.
          </p>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="row">
            <div class="col-sm-12 col-md-9">
              <div class="px-3 pb-2 pt-5 add-new-folder">
                <h4>Add Your Department</h4>
                <p class="d-flex flex-column">
                  <input type="text" placeholder="Enter department name" class="w-75" v-model="department"
                    @input="check" />
                  <span class="error" v-if="error">Please enter department name</span>
                  <span class="error" v-if="department_name_exist">This department already exist</span>
                </p>
                <p class="assign">
                  <input type="checkbox" v-model="create_folder" />
                  <span>Create a folder for this department in Group Folder</span>
                </p>
                <p class="my-3">
                  <span class="save-btn" @click="create_department">
                    &plus; Add New Department
                  </span>
                </p>
              </div>
              <div class="px-3 py-3 folder-list">
                <h4>Department List</h4>
                <div>
                  <ul>
                    <li v-for="(department, index) in departments" :key="index" class="d-block">
                      <!-- <span class="d-flex align-items-center">
                            <span class="folder-name">{{ department.name }}</span>
                          </span>
                          <span>
                            <span>
                              <img src="@/assets/edit-button.svg" />
                            </span>&nbsp;&nbsp;&nbsp;
                            <span>
                              <img src="@/assets/delete-button.svg" />
                            </span>
                          </span> -->
                      <div v-if="!department.edit_mode" class="d-flex justify-content-between">
                        <span class="dept-box">{{ department.name }}</span>
                        <span class="
                                action
                                d-flex
                                justify-content-center
                                align-items-center
                              ">
                          <span @click="edit_text(index)" style="cursor: pointer">
                            <img src="@/assets/Edit.svg" />
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <span @click="delete_text(index)" style="cursor: pointer">
                            <img src="@/assets/Gray-Delete-Btn.svg" />
                          </span>
                        </span>
                      </div>
                      <div v-if="department.edit_mode" class="d-flex justify-content-between">
                        <input type="text" class="edit_text" v-model="text" ref="edit" />
                        <span class="
                                action2
                                d-flex
                                justify-content-center
                                align-items-center
                              " style="margin-left: 10px">
                          <span class="cancel-btn" @click="cancel_text(index)" style="cursor: pointer">
                            Cancel
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <span class="save-btn2" @click="save_text(index)" style="cursor: pointer">
                            Save
                          </span>
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
    <editdepartmentload ref="editloader"></editdepartmentload>
    <notify ref="notify"></notify>
    <embeded ref="embed"></embeded>
    <logout ref="logout"></logout>
    <invite ref="invite"></invite>
  </div>
</template>
<style scoped>
.cancel-btn {
  background-color: #fff;
  border: 1px solid #3f96d1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 103px;
  height: 46px;
  font-size: 14px;
  border-radius: 10px;
  color: #3f96d1;
}

.save-btn2 {
  background-color: #3f96d1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 103px;
  height: 46px;
  font-size: 14px;
  border-radius: 10px;
  color: #fff;
}

.error {
  color: #fc6d6c;
}

.folder-list ul li {
  padding: 12px 0 !important;
  margin: 0 !important;
  font-size: 14px !important;
}

.folder-list ul li:hover {
  background: transparent;
}

.folder-list .folder-name {
  color: #111111;
  font-size: 14px;
}

.add-new-folder {
  font-family: "inter";
}

.folder-list {
  font-family: "inter";
}

.folder-list h4 {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.folder-list>div {
  height: 300px;
  overflow-y: auto;
  padding-right: 20px;
}

.add-new-folder h4 {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}

.save-btn {
  background-color: #3f96d1;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 46px;
  font-size: 14px;
  border-radius: 10px;
  color: #fff;
}

.update-body {
  width: 92% !important;
  padding: 0 !important;
  height: 630px !important;
}

.update-body .row {
  height: 100%;
}

.update-body-nav {
  height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: "inter";
}

.update-body-nav h4 {
  color: #000;
}

.department {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8em;
}

.department select {
  border: 1px solid #e1e1e1;
  padding: 0.8em 0.5em;
}

.assign {
  margin: 12px 0;
}

.assign label {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 13px;
}

.assign input {
  margin-right: 0.4em;
  width: auto;
}

.add-department .error {
  color: #fc6d6c;
}

.form {
  background: #f9f9f97e url("../../public/bg.png");
  height: calc(100% - 160px);
  text-align: left;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1em;
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form input[type="text"] {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
}

.form .btn {
  cursor: pointer;
  background: #0071e0;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.listed-department {
  background: #fff;
  padding: 1em;
  width: 35%;
  height: auto;
}

.listed-department li {
  display: flex;
  align-items: center;
}

.listed-department li span {
  margin-left: 0.4em;
}

.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}

p {
  margin: 0;
}

.add-department p:first-child {
  margin-bottom: 0.6em !important;
}

.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}

span.create_public {
  display: block;
  margin-top: 0.5em;
}

span.create_public label input {
  display: inline !important;
  /*width: auto !important;*/
}

.add-department .error {
  color: #fc6d6c;
}

.form {
  background: #f9f9f97e url("../../public/bg.png");
  height: calc(100% - 160px);
  text-align: left;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 1em;
}

.form .add-department {
  width: 30%;
}

.form .add-department h4 {
  font-weight: bold;
}

.form input {
  width: 100%;
  border: 1px solid #f1f1f1;
  border-radius: 3px;
  padding: 1em 1em;
}

.form .btn {
  cursor: pointer;
  background: #0071e0;
  color: #fff;
  border-radius: 3px;
  padding: 1em 1em;
  display: inline-block;
  text-align: center;
  width: 100%;
}

.top-header {
  border-bottom: 1px solid #f9f9f9;
}

.undraw {
  width: 20%;
}

.undraw img {
  max-width: 100%;
}

.bottom-pane {
  text-align: left;
}

.listed-department {
  background: #fff;
  padding: 1em;
  width: 35%;
  height: auto;
}

.listed-department li {
  display: flex;
  align-items: center;
  margin-bottom: 0.9em;
}

.listed-department li span {
  margin-left: 0.4em;
}

.bottom-pane h1 {
  font-size: 50px;
  font-weight: bold;
  color: #000;
}

p {
  margin: 0;
}

.add-department p:first-child {
  margin-bottom: 0.6em !important;
}

.bottom-pane {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-top: 0.9em;
}

.listed-department ul li .department-mode {
  display: flex !important;
  justify-content: space-between !important;
  width: 100%;
}

.listed-department ul li .department-mode .text-field {
  flex-grow: 2;
}

.listed-department ul li .department-mode .text-field input {
  width: 80%;
  padding: 0.4em 0.5em;
}

.action span {
  cursor: pointer;
}

input[name="create_folder"] {
  width: auto;
}
</style>

<script>
import loading from "@/components/Loading";
import TopHeader from "@/components/Top-Header";
import AuthenticationService from "../services/AuthenticationService";
import logout from "@/components/Logout";
import editdepartmentload from "@/components/Edit-Department-Loading";
import notify from "@/components/Notify";
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import embeded from "@/components/Embed";
import invite from "@/components/Invite";

export default {
  components: {
    TopHeader,
    loading,
    editdepartmentload,
    notify,
    embeded,
    invite,
    logout,
  },
  data() {
    return {
      answer: "",
      error: false,
      department: "",
      departments: [],
      name: "",
      post: true,
      department_name_exist: false,
      create_folder: false,
      close_toastr: false,
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      position: localStorage.getItem("position"),
      account_type: localStorage.getItem("account_type"),
      text: "",
    };
  },
  methods: {
    ...mapMutations([
      "SET_FILE_ACTION",
      "REMOVE_FILE_ACTION",
      "SET_DIRECTORY_CHILDREN",
      "TOGGLE_FILE_INFO",
      "SORT_DIRECTORY_CHILDREN",
      "SORT_STORED_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "GET_DIRECTORY_CHILDREN",
      "CLOSE_FILE_INFO",
      "SET_PATH",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "UPDATE_TOTAL_CREATED_IMAGES",
      "UPDATE_TOTAL_CREATED_DOCUMENTS",
      "UPDATE_TOTAL_CREATED_FOLDERS",
      "SET_FIRSTNAME",
      "SET_LASTNAME",
      "SET_EMAIL",
      "SET_PHONE",
      "SET_POSITION",
      "SET_DEPARTMENT",
      "SET_COUNTRY",
      "SET_DATE_CREATED",
      "SET_ACCT_TYPE",
      "SET_ISADMIN",
      "SET_PHOTO",
      "UPDATE_TOTAL_SPACE",
      "UPDATE_DEFAULT_FOLDER",
      "UPDATE_TOTAL_USED_SPACE",
      "SET_ISTRIAL",
      "SET_ISSTAFF",
      "SET_ISSUPERADMIN",
      "SET_PATH",
      "SORT_DIRECTORY_CHILDREN",
      "SET_CURRENT_DIRECTORY",
      "SET_CURRENT_PLAN",
      "UPDATE_PUBLIC_FOLDER_ID",
      "HIDE_FILE_INFO",
      "SET_FILE_ACTION",
      "SET_SELECT_ALL",
      "SET_USER_PLAN",
      "UPDATE_USER",
      "SET_NAME",
      "SET_IS_SECURITY_QUESTION",
      "SET_PLAN_STATUS",
      "SET_TRIAL_STATUS",
      "SET_HAS_CRM",
      "SET_HAS_INVEX",
      "SET_INVEX_DOMAIN",
      "SET_INVEX_API_URL"
    ]),
    change_pic() {
      this.UPDATE_SLIDEIN(false);
      this.UPDATE_SLIDEOUT(true);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(false);

      this.$refs.pic.click();
    },
    invite() {
      this.$refs.invite.load();
    },
    start_upload() {
      this.$refs.startupload.load(this.$refs.pic.files[0]);
      this.$refs.pic.value = "";
    },
    slideout($evt) {
      if ($evt.target.tagName === "svg" || $evt.target.tagName === "path") {
        this.UPDATE_SLIDEIN(false);
        this.UPDATE_SLIDEOUT(true);
        this.UPDATE_MENU(false);
        this.UPDATE_BODY_MENU(false);
      } else {
        if ($evt.target.classList.contains("menubody")) {
          this.UPDATE_SLIDEIN(false);
          this.UPDATE_SLIDEOUT(true);
          this.UPDATE_MENU(false);
          this.UPDATE_BODY_MENU(false);
        }
      }
    },
    check(evt) {
      if (evt.target.value !== "") {
        this.error = false;
        this.department_name_exist = false;
      }
    },
    save_text(index) {
      this.$refs.editloader.load();

      let data = {
        id: this.departments[index]._id,
        token: cookies.getCookie("token"),
        name: this.text,
      };

      let text = this.text;
      let that = this;

      AuthenticationService.edit_department(data)
        .then((res) => {
          if (res.data.data == true) {
            that.$refs.editloader.close();
            that.departments[index].name = text;
            that.departments[index].edit_mode = false;
          }

          if (res.data.result == false) {
            that.$router.push("login");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit_text(index) {
      this.departments.map((d) => {
        d.edit_mode = false;
      });
      // this.text = this.departments[index].name
      this.departments[index].edit_mode = true;
      this.text = this.departments[index].name;
      // this.$refs.edit[index].autofocus = true
    },
    delete_text(index) {
      this.$refs.loading.load();

      let data = {
        id: this.departments[index]._id,
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("delete-department", data, function (data) {
        if (data.data === true) {
          if (data.found === 0) {
            that.$refs.loading.close();
            that.departments.splice(index, 1);
          } else {
            that.$refs.loading.close();
            that.$refs.notify.load(
              "This deparment(" +
              that.departments[index].name +
              ") has " +
              data.found +
              " users in it"
            );
          }
        }

        if (data.data == false) {
          that.$router.push("login");
        }
      });
    },
    cancel_text(index) {
      this.departments[index].edit_mode = false;
    },
    notifyexpiration(text) {
      this.$refs.notify.load(text);
    },
    create_department() {
      if (this.$store.getters.ISTRIAL) {
        if (!this.$store.getters.TRIAL_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      } else {
        if (!this.$store.getters.PLAN_STATUS) {
          if (this.$store.getters.ISSTAFF) {
            this.notifyexpiration(
              "Your trial period has expired. Please contact your admin"
            );
            return;
          } else {
            this.notifyexpiration(
              'Your trial period has expired. <a href="/payments-billing">Payments & Billing</>'
            );
            return;
          }
        }
      }

      if (this.department == "") {
        this.error = true;
      } else {
        this.error = false;
        this.department_name_exist = false;
        this.$refs.loading.load();

        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          name: this.department,
          create_folder: this.create_folder,
        };

        AuthenticationService.create_department(data)
          .then((res) => {
            if (res.data.data === true) {
              that.department = "";
              that.$refs.loading.close();
              that.create_folder = false;

              that.departments.push({
                _id: res.data.id,
                name: res.data.name,
                edit_mode: false,
              });
            }

            if (res.data.exist === true) {
              that.$refs.loading.close();
              that.department_name_exist = true;
            }

            if (res.data.result == false) {
              that.$router.push("login");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    close() {
      this.error.message = false;
    },
    logout() {
      this.$refs.logout.logout();
    },
    user_data() {
      let data = {
        token: cookies.getCookie("token"),
      };

      let that = this;

      this.$socket.emit("get-data", data, function (data) {
        if (data.data === true) {
          that.SET_ACCT_TYPE(data.account_type);
          that.SET_ISADMIN(data.isSuperAdmin);
          that.SET_FIRSTNAME(data.firstname);
          that.SET_LASTNAME(data.lastname);
          that.SET_NAME(data.firstname + " " + data.lastname);
          that.SET_EMAIL(data.email);
          that.SET_PHONE(data.phone);
          that.SET_POSITION(data.position);
          that.SET_DEPARTMENT(data.department);
          that.SET_COUNTRY(data.country ? data.country : "");
          that.SET_DATE_CREATED(data.date_created);
          that.SET_PHOTO(data.photo);
          that.UPDATE_TOTAL_SPACE(data.total_space);
          that.UPDATE_TOTAL_USED_SPACE(data.total_space_used);
          that.UPDATE_USER(data.id);
          that.SET_CURRENT_PLAN(data.current_plan);
          that.SET_USER_PLAN(data.user_plan);
          that.SET_PLAN_STATUS(data.isPlanActive);
          that.SET_TRIAL_STATUS(data.isTrialActive);
          that.SET_HAS_CRM(data.hasCrm);
          that.SET_HAS_INVEX(data.hasInvex);
          that.SET_INVEX_DOMAIN(data.invex_domain);
          that.SET_INVEX_API_URL(data.invex_api_url);
          that.SET_ISTRIAL(data.isTrial);
          that.SET_ISSTAFF(data.isStaff);
          that.SET_ISSUPERADMIN(data.isSuperAdmin);

          that.SET_IS_SECURITY_QUESTION(data.is_security_question);

          that.UPDATE_DEFAULT_FOLDER(data.default_folders);

          that.UPDATE_PUBLIC_FOLDER_ID(data.public_folder_id);
          localStorage.setItem("id", data.id);
          localStorage.setItem("email", data.email);
          localStorage.setItem(
            "is_security_question",
            data.is_security_question
          );
          sessionStorage.setItem("gi", data.group_folder_id);
          sessionStorage.setItem("pi", data.project_folder_id);

          that.UPDATE_TOTAL_CREATED_IMAGES(data.total_created_images);
          that.UPDATE_TOTAL_CREATED_DOCUMENTS(data.total_created_documents);
          that.UPDATE_TOTAL_CREATED_FOLDERS(data.total_created_folders);
        }
      });
    },
  },
  mounted() {
    this.user_data();

    let that = this;
    if (
      cookies.getCookie("token") != "" &&
      cookies.getCookie("token") != null
    ) {
      let data = {
        token: cookies.getCookie("token"),
      };

      this.$socket.emit("url:auth", data, (data) => {
        if (data.data == false) {
          that.$router.push("/login");
        } else {
          that.name = data.name;

          that.$socket.emit(
            "get-departments",
            { token: cookies.getCookie("token") },
            function (data) {
              if (data.data === true) {
                that.departments = data.departments;
                console.log(that.departments);
              }
            }
          );
        }
      });
    } else {
      this.$router.push("/login");
    }
  },
};
</script>
